module.exports = __webpack_public_path__ + "ec3b2207781cbdb9f05f3a6ce2e5e279.png";